app.controller("ApartmentBlockController", ["$scope", "ApartmentSearchModel", "$filter", function($scope, ApartmentSearchModel, $filter) {
	$scope.Utils = window.Utils;

	// Because toLocaleString('fi') isn't so supported in old/mobile browsers
	$scope.formatArea = function(area) {
		// Only format if needed, we have decimals and remove trailing zeroes
		if (area % 1 !== 0) {
			area = $filter("number")(area, 2);
			return area.replace(/0$/, "").replace(".", ",");
		}
		return area;
	};

	$scope.getApartmentArea = function(apartment) {
		var area = "";
		var landArea = null;
		// Tontti, ensisijaisesti landArea
		if (apartment.group.toUpperCase() == "TO") {
			landArea = $scope.getLandArea($scope.apartment);
			if (landArea != null) {
				return landArea;
			}
		}
		// Asuinpinta-ala, jos on
		if ($scope.apartment.livingArea != null) {
			return $scope.formatArea($scope.apartment.livingArea) + " m²";
		} else {
			// Jos asuinpinta-alaa ei ole, esim. maa- ja metsätilat, niin kokeillaan vielä landAreaa
			landArea = $scope.getLandArea($scope.apartment);
			if (landArea != null) {
				return landArea;
			}
		}
		return area;
	};

	$scope.getLandArea = function(apartment) {
		if (apartment.landOwnership.landArea_m2 && apartment.landOwnership.landArea_ha) {
			if (apartment.landOwnership.landArea_m2 > 10000) {
				return $scope.formatArea(apartment.landOwnership.landArea_ha) + " ha";
			} else {
				return $scope.formatArea(apartment.landOwnership.landArea_m2) + " m²";
			}
		} else if (apartment.landOwnership.landArea_m2) {
			return $scope.formatArea(apartment.landOwnership.landArea_m2) + " m²";
		} else if (apartment.landOwnership.landArea_ha) {
			return $scope.formatArea(apartment.landOwnership.landArea_ha) + " ha";
		}
		// KMD-14
		if (!apartment.area && apartment.housingCompany !== undefined && apartment.housingCompany.area > 0) {
			return $scope.formatArea(apartment.housingCompany.area) + " m²";
		}
		return null;
	};

	if (typeof $scope.apartment != "undefined") {
		if (typeof $scope.apartment.images[0] != "undefined") {
			$scope.apartment.image =
				"/assets" +
				$scope.apartment.images[0].path +
				"/w_604,h_" +
				($scope.apartment.newConstruction && !$scope.apartment.valueListing ? "174" : "392") +
				",c_zoom/" +
				$scope.apartment.images[0].name;
			$scope.apartment.similarImage =
				"/assets" + $scope.apartment.images[0].path + "/w_500,h_200,c_zoom/" + $scope.apartment.images[0].name;
		}
		if (typeof $scope.apartment.images[2] != "undefined") {
			$scope.apartment.tinyImage =
				"/assets" + $scope.apartment.images[2].path + "/w_222,h_135,c_zoom/" + $scope.apartment.images[2].name;
		}

		$scope.apartment.area = $scope.getApartmentArea($scope.apartment);

		var now = Math.round(new Date().getTime() / 1000);
		for (var o in $scope.apartment.openHouses) {
			if ($scope.apartment.openHouses.hasOwnProperty(o)) {
				if ($scope.apartment.openHouses[o].end.sec > now) {
					$scope.apartment.openHouse = $scope.apartment.openHouses[o];
					break;
				}
			}
		}

		var priceValue = $filter("currency")($scope.apartment.salesPriceUnencumbered, "", ",", " ", 0) + " €";
		if ($scope.apartment.rental) {
			$scope.priceTitle = "Vuokra ";
			$scope.priceTitleLong = "Vuokra ";
			$scope.priceValue = $scope.apartment.rentInfo.rentPerMonth + "€/kk";
		} else if ($scope.apartment.onlineOffer) {
			$scope.priceTitle = "Lähtöhinta ";
			$scope.priceTitleLong = "Velaton lähtöhinta ";
			$scope.priceValue = priceValue;
		} else {
			$scope.priceTitle = "Velaton hinta ";
			$scope.priceTitleLong = "Velaton hinta ";
			$scope.priceValue = priceValue;
		}
	}

	$scope.GetTileType = function(apartment) {
		if (apartment.valueListing) {
			return "large";
		} else if (apartment.newConstruction) {
			return "medium";
		} else {
			return "small";
		}
	};

	$scope.ParseOpenHouseDate = function(secs) {
		var date = $filter("date")(secs * 1000, "EEEE dd.MM klo HH:mm");
		return date.replace(/^\w/, function(chr) {
			return chr.toUpperCase();
		});
	};
}]);
